import type { IRoute } from '@app/routes';

export const isAccordionExpanded = (sublinks: IRoute[], pathname: string): boolean => {
  return sublinks.some(
    sublink => pathname === sublink.url || pathname.startsWith(sublink.url + '/'),
  );
};
